import produce from 'immer';

import { KEYWORD_TYPES, KeywordActions, KeywordState } from './keywordTypes';
import { API_REQUEST_STATE } from '../../../core/enums/apiRequestState';

const initialState: KeywordState = {
  apiKeywordRequestState: API_REQUEST_STATE.IDLE,
  apiKeywordRequestError: null,
  apiKeywordsRequestState: API_REQUEST_STATE.IDLE,
  apiKeywordsRequestError: null,
  keyword: {
    name: '',
    iri: '',
  },
  keywords: [],
};

export const keywordReducer = produce((draft: KeywordState, action: KeywordActions) => {
  switch (action.type) {
    case KEYWORD_TYPES.RESET:
      draft.keyword = initialState.keyword;
      break;
    case KEYWORD_TYPES.SET_API_KEYWORD_REQUEST_ERROR:
      draft.apiKeywordRequestError = action.payload.apiKeywordRequestError;
      break;
    case KEYWORD_TYPES.SET_API_KEYWORD_REQUEST_STATE:
      draft.apiKeywordRequestState = action.payload.apiKeywordRequestState;
      break;
    case KEYWORD_TYPES.SET_API_KEYWORDS_REQUEST_ERROR:
      draft.apiKeywordsRequestError = action.payload.apiKeywordsRequestError;
      break;
    case KEYWORD_TYPES.SET_API_KEYWORDS_REQUEST_STATE:
      draft.apiKeywordsRequestState = action.payload.apiKeywordsRequestState;
      break;
    case KEYWORD_TYPES.GET_ONE_SUCCESS:
      draft.keyword = action.payload.keyword;
      break;
    case KEYWORD_TYPES.GET_ALL_SUCCESS:
      draft.keywords = action.payload.keywords;
      break;
  }
}, initialState);
